import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty, isArray, isString } from 'lodash';

const Certification = ({ certificationText, certificationBadge, extraClasses }) => {
    const wrapperClass = ['vehicle-certification-single', 'is-light'];
    if (certificationText === '') {
        return null;
    } else if (certificationBadge) {
        return (
            <img
                className={`certification-badge__image ${extraClasses}`}
                alt={certificationText}
                src={certificationBadge}
            />
        );
    }
    if (!isEmpty(extraClasses) && isArray(extraClasses) && extraClasses.length > 0) {
        extraClasses.forEach((singleClass) => {
            if (isString(singleClass) && singleClass !== '') {
                wrapperClass.push(singleClass);
            }
        });
    } else if (!isEmpty(extraClasses) && extraClasses !== '' && isString(extraClasses)) {
        wrapperClass.push(extraClasses);
    }
    return (
        <div className={wrapperClass.join(' ')}>
            <p className="is-light">{certificationText}</p>
        </div>
    );
};

Certification.defaultProps = {
    certificationText: '',
    certificationBadge: '',
    extraClasses: [''],
};

Certification.propTypes = {
    certificationText: PropTypes.string,
    certificationBadge: PropTypes.string,
    extraClasses: PropTypes.arrayOf(PropTypes.string),
};

Certification.displayName = 'Tile.Certification';

export default Certification;
